import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import {Container,Grid} from '@material-ui/core';
import { useDispatch, useSelector} from 'react-redux';
import PRModel from '../../models/pressrelease-downloads.model';
import pageMeta from '../../models/pagemeta.model';
import { useEffect } from 'react';
import Preloader from '../../components/PreLoader';
import { lang } from '../../config/app.config';
import Paginate from '../../components/pagination';
import { fetchPR } from '../../services/press-download.service';
import { useParams } from 'react-router';
// import translate from '../../translation.json';
// import moment from 'moment';
// import {IoCalendar} from 'react-icons/io5';
import InfoCard from '../../components/infoCard';
import {TranslationState} from '../../store/ActionReducers/translation.actionreducer';

interface state{
  pressrelease:{
    pressReleases:Array<PRModel>,
    loadingPressRelease:boolean,
    metaPressRelease:pageMeta
  }
}
interface params{
  dist_slug:string
}

const PR:React.FC = ()=>{

  // redux store
  const dispatch = useDispatch();
  const {dist_slug} = useParams<params>();


  const state = useSelector((state:state)=>{
    const {pressrelease} = state; 
    return pressrelease;
  }); 
  const {loadingPressRelease,pressReleases,metaPressRelease} = state;
  const stateTr = useSelector((state:{translation:TranslationState})=>state.translation);


  //end redux store

  //load pr
  const loadPR = (page:number = 1) =>{
    dispatch(fetchPR(page,dist_slug));
  }


  useEffect(()=>{
    loadPR();
  },[dispatch]) //eslint-disable-line



  return(
    <>
    {loadingPressRelease?<Preloader/>:
      <>
      <Breadcrumb routes={[{title:stateTr.translation?stateTr.translation.press_release[lang==='np'?"value_np":"value_en"]:""}]} slug="press-release"/>
       <div className="text-center curveBackground">
         <h3 className="ecn-title-inv text-26">{stateTr.translation?stateTr.translation.press_release[lang==='np'?"value_np":"value_en"]:""}</h3>
       </div>
       <div className="section-padding-2">
         <Container maxWidth="lg">
           <Grid container spacing={3} className="justify-content-center">
             {pressReleases && pressReleases.length?
                pressReleases.map((n)=>(
                <Grid item xs={12} md={10} key={n.id}>
                  <InfoCard data={n}/>
                </Grid>
                )): 
               <h3 className="text-center section-break-4 text-28-primary">
                Sorry no press releases found!!
               </h3> // no news
             }
           </Grid>
           <div className="section-break-2 text-center">
             <Paginate meta={metaPressRelease} paginate={loadPR} />
           </div>
         </Container>
       </div>
     </>
    }
    </>
  );
}

export default PR;